import { render, staticRenderFns } from "./matriculaPay.vue?vue&type=template&id=349b285c&"
import script from "./matriculaPay.vue?vue&type=script&lang=js&"
export * from "./matriculaPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports